<template>
  <div class="vld-parent" ref="investor_batches">
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você confere todos os batch de startups pertencentes aos
              fundos de investimentos nos quais você participa. Em caso de
              dúvidas, não hesite em contatar o suporte.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt-5">
      <div class="d-flex justify-content-center row">
        <card class="bg-warning p-4">
          <h1>
            <i class="fa fa-exclamation-triangle text-lg mr-2"></i>Página em
            manutenção <i class="fa fa-exclamation-triangle text-lg"></i>
          </h1>
          <p class="text-black">
            Prezado investidor, estamos trabalhando para melhorar a sua
            experiência. Em breve, você poderá conferir todos os batches de
            startups STARS vinculados aos seus veículos de investimento.
          </p>
        </card>
      </div>
      <!-- <div class="row">
        <div class="col">
          <div v-if="!empty" class="card-deck">
            <div
              class="col-lg-4 col-md-6 d-flex align-items-stretch mb-5 mt-3"
              v-for="batch in batches"
              :key="batch.id"
            >
              <div class="card card-profile shadow flex-grow-1">
                <div class="row justify-content-center">
                  <div class="col-lg-3 order-lg-2">
                    <div class="card-profile-image">
                      <img src="/img/pages/batch.png" class="rounded-circle" />
                    </div>
                  </div>
                </div>
                <div class="card-body pt-7 pb-1">
                  <div class="text-center mt-5">
                    <h2 class="text-center tag-title">
                      <span class="tag text-warning">{{ batch.name }}</span>
                    </h2>
                    <div class="col-12 text-center">
                      <badge type="info">{{
                        batch.status === "open" ? "Regular" : "Encerrado"
                      }}</badge>
                    </div>
                    <div class="row mt-md-3 mb-2">
                      <div class="col text-center text-muted">
                        Batch de
                        <span class="text-warning">{{ batch.type }} STARS</span
                        >, pertencente ao fundo de investimentos
                        <span class="font-weight-bold text-dark">{{
                          batch.fundTag
                        }}</span
                        >.
                      </div>
                    </div>
                    <h3>
                      Duração:
                      <span class="font-weight-light">
                        {{ formatDate(batch.start_date, "L") || "..." }}
                        até
                        {{ formatDate(batch.end_date, "L") || "..." }}
                      </span>
                    </h3>
                  </div>
                </div>
                <div class="card-footer text-center">
                  <base-button
                    type="danger"
                    :custom="true"
                    class="mt-1"
                    @click="
                      $router.push(
                        '/investidor/batches/' + batch.id + '/startups'
                      )
                    "
                    >ver startups</base-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-12 text-center">
              <badge type="info" class="bg-white">
                Não há batches de startups STARS cadastrados em seus fundos de
                investimentos
              </badge>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <modal
      :show.sync="empty"
      :closeOnClick="false"
      modal-classes="modal-dialog-centered modal-default"
    >
      <h6 class="modal-title mb-5" id="modal-title-notification">Atenção!</h6>
      <div class="text-center">
        <i class="fa fa-exclamation-circle fa-3x"></i>
        <h4 class="heading mt-4">
          Prezado
          <span class="text-warning text-default-case">investidor</span>,
        </h4>
        <p class="my-4">
          Não há nenhum
          <span class="text-warning font-weight-400"
            >batch de startups STARS</span
          >
          vinculado aos fundos de investimentos nos quais você está cadastrado.
          Em caso de dúvidas, sinta-se livre para
          <base-button
            type="danger"
            class="ml-auto"
            size="sm"
            @click="$router.push('/investidor/suporte')"
            >Contatar o suporte
          </base-button>
        </p>
        <p class="text-right mt-5 mb-0">
          Cordialmente,<br />
          <span class="font-weight-600"
            >Equipe <span class="text-warning">STARS</span></span
          >.
        </p>
      </div>
      <template slot="footer">
        <base-button type="white" @click="$router.push('/')">
          Voltar ao menu inicial
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "batches",
  data() {
    return {
      batches: [],
      empty: false,
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.investor_batches,
      width: 150,
      height: 150,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    try {
      const { data } = await api.get("/investor-batches");
      if (data.length) this.batches = data;
      else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
    }
  },
};
</script>
<style scoped>
.card {
  margin-top: 10px;
}
.card-profile-image img {
  width: 180px;
  height: 180px;
}
.text-default-case {
  text-transform: none !important;
}
</style>
